import { render, staticRenderFns } from "./_languages.vue?vue&type=template&id=4ea2204c"
import script from "./_languages.vue?vue&type=script&lang=js"
export * from "./_languages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports